import React from "react";
import {useTranslation} from "react-i18next";
import {useHistory, useLocation} from "react-router-dom";
import useCookieConsent from "../../hooks/useCookieConsent";
import Button from "../basics/button/Button";
import Card from "../basics/card/Card";
import "./_cookie-acceptance.scss";

export default function CookieAcceptance() {
    const {t, ready} = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const {hasDecision, acceptAll, rejectOptional} = useCookieConsent();

    if (hasDecision || location.pathname === "/cookies" || !ready) return null;

    return (
        <Card className="cookie-acceptance" role="dialog">
            <div className="cookie-acceptance__content">
                <h2>{t("cookies.banner.title")}</h2>
                <p>{t("cookies.banner.description")}</p>
            </div>
            <div className="cookie-acceptance__actions">
                <Button
                    buttonStyle="text"
                    buttonColor="secondary"
                    type="button"
                    onClick={rejectOptional}>
                    {t("cookies.actions.rejectOptional")}
                </Button>
                <Button
                    buttonStyle="bordered"
                    buttonColor="primary"
                    type="button"
                    onClick={() => history.push("/cookies")}>
                    {t("cookies.actions.settings")}
                </Button>
                <Button buttonColor="primary" type="button" onClick={acceptAll}>
                    {t("cookies.actions.acceptAll")}
                </Button>
            </div>
        </Card>
    );
}
